import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation"; // optional if AOS.init is in RootLayout
import RootLayout from "./layout";
import arts from "../assets/images/activity/art.jpg";
import arts1 from "../assets/images/activity/art1.jpg";
import arts2 from "../assets/images/activity/art2.jpg";
import skills from "../assets/images/activity/life.jpg";
import skills1 from "../assets/images/activity/life1.jpg";
import skills2 from "../assets/images/activity/life2.jpg";
import pe from "../assets/images/activity/play.jpg";
import pe1 from "../assets/images/activity/play1.jpg";
import pe2 from "../assets/images/activity/play2.jpg";
import news from "../assets/images/activity/news.jpg";
import news1 from "../assets/images/activity/news1.jpg";
import news2 from "../assets/images/activity/news2.jpg";
import Slider from "react-slick";

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const CoScholasticProgram = () => {
  const artsImages = [arts, arts1, arts2];
  const peImages = [pe, pe1, pe2];
  const skillsImages = [skills, skills1, skills2];
  const newsImages = [news, news1, news2];
  return (
    <>
      <RootLayout>
        {/* If AOS is initialized in RootLayout, you can remove <Animation /> */}
        <Animation />
        <HeaderOne />
        <Breadcrumb title={"Co-Scholastic Program"} />

        <section className="join-community">
          <div className="container container--lg">
            <div className="rounded-20 py-60 px-8">
              <div className="container">
                {/* Intro */}
                <div className="row gy-4 align-items-center">
                  <div className="col-lg-12">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h2
                          className="mb-24"
                          data-aos="fade-up"
                          data-aos-duration="800"
                        >
                          Co-Scholastic Programme
                        </h2>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-duration="800"
                          data-aos-delay="120"
                        >
                          Welcome to <b>NPS Kudlu</b>, the home of exceptional
                          co-scholastic programs that will unleash your child’s
                          full potential!
                          <br />
                          <br />
                          We understand that a child’s education should go
                          beyond just academics. That’s why we have carefully
                          crafted our co-scholastic programs to offer a wide
                          range of exciting and stimulating activities that help
                          your child develop in all areas of life.
                          <br />
                          <br />
                          From sports and fitness to music, dance, and the arts,
                          our programs are designed to cater to a wide variety
                          of interests and passions. Whether your child is a
                          budding musician, an aspiring artist, or a sports
                          enthusiast, we have something for everyone.
                          <br />
                          <br />
                          Our experienced instructors work closely with students
                          to provide personalized guidance and support, helping
                          them explore their talents and develop new skills.
                          <br />
                          <br />
                          At NPS Kudlu, we believe co-scholastic programs are
                          essential to a well-rounded education. They build
                          physical, emotional, and intellectual growth—and
                          develop teamwork, leadership, and resilience.
                          <br />
                          <br />
                          If you’re looking for one of the best CBSE schools in
                          Bangalore with exceptional co-scholastic programs,
                          look no further than NPS Kudlu.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Arts */}
                <div className="row gy-4 align-items-center">
                  <div className="col-lg-8">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Arts
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          Arts education includes music, dance, theatre, and
                          visual arts. The Arts support learning across subjects
                          and develop fine motor skills, creativity, and
                          emotional balance.
                          <br />
                          <br />
                          Thinking skills used in making visual
                          art—experimentation, exploration, imagination—become
                          the foundation for higher-order skills like synthesis,
                          inquiry, and research.
                          <br />
                          <br />
                          Our Arts teachers advance student creativity, visual
                          communication, artistic technique, and aesthetic
                          sensibility.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-lg-4"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="join-community__thumb text-end position-relative">
                      <Slider
                        {...sliderSettings}
                        className="rounded-12 overflow-hidden"
                      >
                        {artsImages.map((img, i) => (
                          <div key={i}>
                            <img
                              src={img}
                              alt=""
                              className="w-100 rounded-12"
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>

                {/* Physical Education */}
                <div className="row gy-4 mt-2 align-items-center">
                  {/* Image */}
                  <div className="col-lg-4" data-aos="zoom-in">
                    <Slider
                      {...sliderSettings}
                      className="rounded-12 overflow-hidden"
                    >
                      {peImages.map((img, i) => (
                        <div key={i}>
                          <img src={img} alt="" className="w-100 rounded-12" />
                        </div>
                      ))}
                    </Slider>
                  </div>
                  {/* Text */}
                  <div className="col-lg-8">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Physical Education
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          Our PE programme builds fitness, teamwork, leadership,
                          and sportsmanship—boosting physical health, cognition,
                          and social skills. Students thrive both on and off the
                          field at National Public School Kudlu.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Life Skills Education */}
                <div className="row gy-4 mt-2 align-items-center">
                  {/* Text */}
                  <div className="col-lg-8">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Life Skills Education
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          Education goes beyond the classroom. Our life skills
                          programme focuses on communication, critical thinking,
                          problem-solving, decision-making, and
                          leadership—skills essential for success in today’s
                          world.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Image */}
                  <div className="col-lg-4" data-aos="zoom-in">
                    <Slider
                      {...sliderSettings}
                      className="rounded-12 overflow-hidden"
                    >
                      {skillsImages.map((img, i) => (
                        <div key={i}>
                          <img src={img} alt="" className="w-100 rounded-12" />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>

                {/* Newspaper in Education (NIE) */}
                <div className="row gy-4 mt-2 align-items-center">
                  {/* Image */}
                  <div className="col-lg-4" data-aos="zoom-in">
                    <Slider
                      {...sliderSettings}
                      className="rounded-12 overflow-hidden"
                    >
                      {newsImages.map((img, i) => (
                        <div key={i}>
                          <img src={img} alt="" className="w-100 rounded-12" />
                        </div>
                      ))}
                    </Slider>
                  </div>
                  {/* Text */}
                  <div className="col-lg-8">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          Newspaper in Education (NIE)
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          NIE builds critical reading, awareness of current
                          events, and meaningful discussion. Teachers use
                          newspapers as a tool across subjects—from science and
                          technology to civics and social issues.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /container */}
            </div>
          </div>
        </section>

        <FooterThree />
      </RootLayout>
    </>
  );
};

export default CoScholasticProgram;
